import { DateInterval } from '../../types/entities';
import { BarSize, WhatToShow } from '../../types/enums';

export interface GraphPresetStateByKey {
  barSize: BarSize;
  durationInDays: number;
  whatToShow: WhatToShow;
  useRth: boolean;
  useDateLock: boolean;
  interval: DateInterval;
  startDate?: string;
  endDate?: string;
  updatedTimestamp: number;
  periodFilter: 'all' | '60' | '30';
}

export interface GraphPresetState {
  [key: string]: GraphPresetStateByKey;
}

export const initialGraphPresetStateByKey: GraphPresetStateByKey = {
  barSize: BarSize._1_DAY,
  durationInDays: 60,
  whatToShow: WhatToShow.TRADES,
  useRth: false,
  useDateLock: true,
  interval: '2M',
  updatedTimestamp: 0,
  periodFilter: 'all'
};

export const initialOrderGraphPresetStateByKey: GraphPresetStateByKey = {
  barSize: BarSize._1_HR,
  durationInDays: 60,
  whatToShow: WhatToShow.TRADES,
  useRth: false,
  useDateLock: true,
  interval: '7D',
  updatedTimestamp: 0,
  periodFilter: 'all'
};

export const initialGraphPresetState: GraphPresetState = {};
